import React from "react";
import { severityColor } from "../utils/colors";

interface TopItem {
  name: string;
  count: number;
  avgSeverity: number;
}

interface TopItemsListProps {
  title: string;
  items: TopItem[];
}

export const TopItemsList: React.FC<TopItemsListProps> = ({ title, items }) => {
  if (!items.length) return null;

  const maxCount = Math.max(...items.map((i) => i.count), 1);

  return (
    <div className="space-y-1.5">
      <h4 className="text-xs font-semibold text-fl-sand/70 uppercase tracking-wide">
        {title}
      </h4>
      {items.map(({ name, count, avgSeverity }) => (
        <div key={name} className="flex items-center gap-2 text-xs">
          <span
            className="w-2 h-2 rounded-full shrink-0"
            style={{ backgroundColor: severityColor(Math.round(avgSeverity)) }}
          />
          <span className="flex-1 truncate text-fl-sand/90">{name}</span>
          <div className="w-16 h-2 bg-white/5 rounded overflow-hidden">
            <div
              className="h-full rounded bg-fl-leaf/60 transition-all duration-500"
              style={{ width: `${(count / maxCount) * 100}%` }}
            />
          </div>
          <span className="w-6 text-right tabular-nums text-fl-sand/60">
            {count}
          </span>
        </div>
      ))}
    </div>
  );
};
